import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import BodyContentType from 'owa-service/lib/contract/BodyContentType';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import popoutCalendarCompose from 'owa-calendar-compose-form-store/lib/utils/popoutCalendarCompose';
import { AddPopoutSource } from 'owa-popout-v2';
import { ClientFolderId } from 'owa-client-ids';
import { assumeDisplayDate, now } from 'owa-datetime';

export default function displayNewAppointmentForm(
    parentFolderId: ClientFolderId,
    requiredAttendees?: AttendeeType[],
    optionalAttendees?: AttendeeType[],
    start?: Date,
    end?: Date,
    location?: EnhancedLocation,
    resources?: AttendeeType[],
    subject?: string,
    body?: BodyContentType
) {
    let item: Partial<CalendarEvent> = {
        ParentFolderId: parentFolderId,
        RequiredAttendees: requiredAttendees || [],
        OptionalAttendees: optionalAttendees || [],
        Locations: location ? [location] : [],
        Resources: resources || [],
        Subject: subject,
        Body: body,
    };

    // TZ_BUG(fpintos): OWA and Desktop Outlook behave differently when responding
    // to the add-in displayNewAppointmentForm call. Desktop Outlook is in
    // the same time zone as the OS, so the new event is created with the
    // face-values of the date in the same time zone expected by the add-in.
    // OWA, on the other hand, takes the face-values of the given Date object
    // and ends up creating the event in OWA's time zone, so it ends up not in
    // the same timestamp. According to the add-in team, this difference is
    // expected and explained here:
    // https://docs.microsoft.com/en-us/office/dev/add-ins/reference/objectmodel/requirement-set-1.7/office.context.mailbox#converttolocalclienttimetimevalue--localclienttimejavascriptapioutlook17officelocalclienttime
    // What this means for us is that we should assume the Date to be a display date.

    item.Start = start ? assumeDisplayDate(start) : now();
    if (end) {
        item.End = assumeDisplayDate(end);
    }

    popoutCalendarCompose(
        item,
        'AddIns' /*entrySource*/,
        null /*originalEvent*/,
        null /*viewState*/,
        AddPopoutSource.Addins
    );
}
